/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_No_ChoiceInputs */

const cs_pm_no_choice = /** @type {(inputs: Pm_No_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez výběru`)
};

const en_pm_no_choice = /** @type {(inputs: Pm_No_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No choice`)
};

/**
* | output |
* | --- |
* | "No choice" |
*
* @param {Pm_No_ChoiceInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_no_choice = /** @type {((inputs?: Pm_No_ChoiceInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_No_ChoiceInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_no_choice(inputs)
	return cs_pm_no_choice(inputs)
});